(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*!
	Zoom 1.7.15
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		$target.css('position', /(absolute|fixed)/.test(position) ? position : 'relative');
		$target.css('overflow', 'hidden');

		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === $target[0]) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			$target = $(target),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false,
			$urlElement;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				$urlElement = $source.find('img');
				if ($urlElement[0]) {
					settings.url = $urlElement.data('src') || $urlElement.attr('src');
				}
				if (!settings.url) {
					return;
				}
			}

			(function(){
				var position = $target.css('position');
				var overflow = $target.css('overflow');

				$source.one('zoom.destroy', function(){
					$source.off(".zoom");
					$target.css('position', position);
					$target.css('overflow', overflow);
					$img.remove();
				});
				
			}());

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					$source
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							} else {
								touched = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
						});
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));

},{}],2:[function(require,module,exports){
'use strict';

var refresh = require('../service/refresh.js');

var $document = $(document);

function submit($form) {

	$.post($form.attr('action'), $form.serialize(), refresh());

	return $form;
}

$document.on('submit', '.js-basket-add', function (e) {

	var $this = $(this);

	$this.addClass('is-disabled');

	$.post($this.attr('action'), $this.serialize(), refresh.then(function () {
		$this.removeClass('is-disabled');
		$this.find('.js-basket-add-clear').val('');
	}));

	e.preventDefault();
});

},{"../service/refresh.js":17}],3:[function(require,module,exports){
'use strict';

$(window).scroll(function () {

	var $scroll = $(window).scrollTop();

	if ($scroll < 30) {
		$('body').addClass('is-top');
	} else {
		$('body').removeClass('is-top');
	}
});

},{}],4:[function(require,module,exports){
'use strict';

$('.checkbox-list').each(function () {

	var $this = $(this);
	var $children = $this.children().not('.checkbox-list__toggle');
	var $count = $this.find('.checkbox-list__count');
	var $hidden = $children.slice(6);

	if ($hidden.length) {
		$this.addClass('is-condensed');
		$hidden.addClass('is-hidden');
		$count.text($hidden.length);
	}
});

},{}],5:[function(require,module,exports){
'use strict';

var equalheight = require('../service/equalheight.js');

$(window).load(function () {
	equalheight('.equalheight');
}).resize(function () {
	equalheight('.equalheight');
});

},{"../service/equalheight.js":16}],6:[function(require,module,exports){
'use strict';

$('.form-item').each(function () {

	var $this = $(this),
	    $input = $('.text-input', $this);

	if ($input.val()) {
		$this.addClass('has-input');
	}

	$input.on('focus', function () {
		$this.addClass('is-active');
	}).on('blur change', function () {
		$this.toggleClass('has-input', $input.val().length > 0);
		$this.removeClass('is-active');
	});
});

},{}],7:[function(require,module,exports){
'use strict';

require('jquery-zoom');

$('.gallery__for').slick({
	asNavFor: '.gallery__nav',
	arrows: false,
	dots: true,
	fade: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	swipe: false

});

$('.gallery__nav').slick({
	asNavFor: '.gallery__for',
	arrows: false,
	focusOnSelect: true,
	draggable: false
});

$('.js-gallery').magnificPopup({

	delegate: 'a',

	gallery: {
		enabled: true
	},

	image: {
		titleSrc: 'title'
	},

	type: 'image'

});

$('.js-gallery a').each(function () {

	var $this = $(this);

	$this.zoom({
		url: $this.attr('href')
	});
});

},{"jquery-zoom":1}],8:[function(require,module,exports){
'use strict';

$('.header__button--search').on('click', function (e) {
	if ($('#search').hasClass('is-active') == false) {

		e.preventDefault();

		setTimeout(function () {
			$('.text-input--search').focus();
		}, 400);
	}
});

},{}],9:[function(require,module,exports){
'use strict';

var $document = $(document);

$document.on('click', '.modal', function (e) {
	if (e.target === this) {
		$(this).removeClass('is-active');
	}
});

$document.on('click', '.js-modal-trigger', function (e) {

	var $this = $(this);
	var $target = $($this.data('target'));

	$.get($this.attr('href'), function (response) {
		$target.html(response).addClass('is-active');
	});

	e.preventDefault();
});

},{}],10:[function(require,module,exports){
'use strict';

$('.slick').slick({
	arrows: false,
	autoplay: true,
	autoplaySpeed: 9000,
	dots: true,
	fade: true,
	pauseOnHover: false,
	speed: 500,
	swipe: true
});

},{}],11:[function(require,module,exports){
'use strict';

var $document = $(document);

$('.tabs').each(function () {

	var $this = $(this),
	    $nav = $this.find('.tabs__nav'),
	    $lis = $nav.children(),
	    $tabs = $this.children('.tabs__tab'),
	    tabIndex,
	    tabs,
	    tabsName = $this.attr('id') || window.location.pathname;

	function selectTab(index) {

		var $tab = $tabs.eq(index),
		    tabBottom,
		    tabTop,
		    tabs,
		    windowTop;

		if ($tab.length == 0) {
			$tab = $tabs.first();
			index = 0;
		}

		$lis.removeClass('is-active').eq(index).addClass('is-active');
		$tabs.removeClass('is-active');
		$tab.addClass('is-active');

		tabTop = $tab.offset().top;
		tabBottom = tabTop + $tab.height();

		windowTop = $document.scrollTop();

		if (tabBottom < windowTop) {
			$document.scrollTop(tabTop);
		}

		if (window.localStorage) {

			tabs = window.localStorage.getItem('tabs');

			if (tabs) {
				tabs = JSON.parse(tabs);
			} else {
				tabs = {};
			}

			tabs[tabsName] = index;

			try {
				window.localStorage.setItem('tabs', JSON.stringify(tabs));
			} catch (error) {
				// nothing
			}
		}
	}

	$nav.on('click', 'a', function (e) {

		var $this = $(this);

		if ($this.attr('href').indexOf('#') == 0) {
			selectTab($lis.index($this.parent()));
			e.preventDefault();
		}
	});

	$tabs.on('click', '> .tabs__title a', function (e) {

		var $this = $(this);

		if ($this.attr('href').indexOf('#') == 0) {
			selectTab($tabs.index($(this).closest('.tabs__tab')));
			e.preventDefault();
		}
	});

	if (window.localStorage) {

		tabs = window.localStorage.getItem('tabs');

		if (tabs) {

			tabs = JSON.parse(tabs);

			if (typeof tabs[tabsName] !== 'undefined') {
				tabIndex = tabs[tabsName];
			}
		}
	}

	if ($this.find('.tabs__tab.is-active').length == 0) {
		if (tabIndex !== undefined) {
			selectTab(tabIndex);
		} else {
			selectTab(0);
		}
	}
});

},{}],12:[function(require,module,exports){
'use strict';

$('.js-typeahead').typeahead({
	hint: true,
	highlight: true,
	minLength: 3
}, {
	name: 'search',
	source: new Bloodhound({
		datumTokenizer: Bloodhound.tokenizers.whitespace,
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		remote: {
			url: '/products/suggestions/%QUERY',
			wildcard: '%QUERY'
		}
	})
});

},{}],13:[function(require,module,exports){
'use strict';

var refresh = require('../service/refresh.js');

var $document = $(document);

$document.on('change', '.js-checkbox-toggle', function () {

	var $checkbox = $(this).find(':checkbox');
	var visible = $checkbox.prop('checked') == false;

	$('.js-checkbox-toggleable').toggle(visible);
}).find('.js-checkbox-toggle').trigger('change');

$document.on('change', '.js-refresh-trigger', function () {

	var $this = $(this);

	$.get($this.attr('action'), $this.serialize(), refresh.within($this.data('scope')));
});

$document.on('change', '.js-submit', function () {
	$(this).trigger('submit');
});

$document.on('click', '.js-toggle', function (e) {

	var $this = $(this),
	    $target,
	    target;

	if ($this.hasClass('js-toggle--touch') == false || Modernizr.touch) {

		if (target = $this.data('target')) {
			$target = $(target);
		} else {
			$target = $this.closest('.js-toggleable');
		}

		if (($this.hasClass('js-toggle--active') && $target.hasClass('is-active')) == false) {
			$target.toggleClass('is-active').siblings().removeClass('is-active');
			e.preventDefault();
		}
	}
});

},{"../service/refresh.js":17}],14:[function(require,module,exports){
'use strict';

var $document = $(document);
var $wrapper = $('.wrapper__inner');

$wrapper.data('position', 0);

$wrapper.slide = function (direction) {

	var position = $wrapper.data('position');
	position += direction;
	position = Math.min(1, Math.max(-1, position));

	$wrapper.update(position);
};

$wrapper.update = function (position) {

	$wrapper.data('position', position);

	$wrapper.toggleClass('is-active', position != 0);
	$wrapper.toggleClass('is-right', position < 0);
};

$wrapper.on('click', function (e) {
	if (e.target == this) {
		$wrapper.update(0);
	}
});

$document.on('click', '.js-menu-toggle', function () {
	$wrapper.update(-1);
});

if (window.Modernizr.touch) {
	$document.swipe({

		swipeLeft: function swipeLeft() {
			$wrapper.slide(0);
		},

		swipeRight: function swipeRight() {
			$wrapper.slide(-1);
		},

		threshold: 100

	});
}

},{}],15:[function(require,module,exports){
'use strict';

require('./component/basket-add.js');
require('./component/body.js');
require('./component/checkbox-list.js');
require('./component/equalheight.js');
require('./component/form-item.js');
require('./component/gallery.js');
require('./component/header.js');
require('./component/modal.js');
require('./component/slick.js');
require('./component/tabs.js');
require('./component/typeahead.js');
require('./component/wrapper.js');

require('./component/utilities.js');

},{"./component/basket-add.js":2,"./component/body.js":3,"./component/checkbox-list.js":4,"./component/equalheight.js":5,"./component/form-item.js":6,"./component/gallery.js":7,"./component/header.js":8,"./component/modal.js":9,"./component/slick.js":10,"./component/tabs.js":11,"./component/typeahead.js":12,"./component/utilities.js":13,"./component/wrapper.js":14}],16:[function(require,module,exports){
'use strict';

module.exports = function (container) {

	var currentTallest = 0;
	var currentRowStart = 0;
	var rowDivs = [];
	var $el;
	var topPosition;

	$(container).each(function () {

		var currentDiv;

		$el = $(this);
		$el.height('auto');
		topPosition = $el.position().top;

		if (currentRowStart != topPosition) {

			for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
				rowDivs[currentDiv].height(currentTallest);
			}

			rowDivs.length = 0; // empty the array
			currentRowStart = topPosition;
			currentTallest = $el.height();
			rowDivs.push($el);
		} else {
			rowDivs.push($el);
			currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
		}

		for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
			rowDivs[currentDiv].height(currentTallest);
		}
	});
};

},{}],17:[function(require,module,exports){
'use strict';

var equalheight = require('../service/equalheight.js');

var refresh = function refresh(selector, state, scope, callback) {

	if (selector == undefined) {
		selector = '.js-refresh-target';
	}

	if (state == undefined) {
		state = 'is-disabled';
	}

	var $targets;

	if (scope) {
		$targets = $(scope).find(selector);
	} else {
		$targets = $(selector);
	}

	$targets.addClass(state);

	return function (response) {

		var _$targets = $('<body />').html(response).find(selector);

		$targets.each(function (index) {
			$(this).html(_$targets.eq(index).html());
		});

		equalheight('.equalheight');

		$targets.removeClass(state);

		if (callback) {
			callback();
		}
	};
};

refresh.within = function (scope) {
	return this(undefined, undefined, scope);
};

refresh.then = function (callback) {
	return this(undefined, undefined, undefined, callback);
};

module.exports = refresh;

},{"../service/equalheight.js":16}]},{},[15]);
